import React, {useEffect, useState} from "react";
import Modal from "react-bootstrap/Modal";
import {Col, Row} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {setDrugInfoModal} from "../../../../../_reducers/DataPanel/Prescription/prescriptionSlice";
import {getGreekCurrencyFormat, isEmpty} from "../../../../../_helpers/commonFunctions";

const DrugInfoModal = () => {
    const dispatch = useDispatch();
    const [show, setShow] = useState(false);
    const drugData = useSelector((state) => state.PRESCRIPTION.drugInfoModal);

    useEffect(() => {
        if (Object.keys(drugData).length > 0) {
            setShow(true);
        } else {
            setShow(false);
        }
    }, [drugData])

    const onHide = () => {
        dispatch(setDrugInfoModal({}));
    }

    return (
        <React.Fragment>
            <Modal show={show} onHide={() => onHide()} dialogClassName={"modal42PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Πληροφορίες Φαρμάκου {drugData?.commercialName && <span>({drugData.commercialName})</span>}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {Object.keys(drugData).length > 0 && (
                        <React.Fragment>
                            <div className={"borderedContainer"}>
                                <Row>
                                    <h6>Βασικά</h6>
                                    <Col md={6}>
                                        <strong>Κατασκευαστής: </strong> {drugData.producer}<br/>
                                        <strong>Εμπορική Ονομασία: </strong> {drugData.commercialName}<br/>
                                        <strong>Μορφή: </strong> {drugData.formCode}<br/>
                                        <strong>Περιεκτηκότητα: </strong> {drugData.content}<br/>
                                        <strong>Συσκευασία: </strong> {drugData.packageForm}<br/>
                                        <strong>ATC: </strong> {drugData.atcCode}<br/>
                                        <strong>Τύπος Φαρμάκου: </strong> {drugData.medicineType}<br/>
                                    </Col>
                                    <Col md={6}>
                                        <strong>Barcode: </strong> {drugData.barcode}<br/>
                                        <strong>Τιμή Αποζημίωσης Ασφαλισμένου: </strong> {getGreekCurrencyFormat(drugData.referenceReducedPrice)}<br/>
                                        <strong>Τιμή Λιανικής: </strong> {getGreekCurrencyFormat(drugData.referencePrice)}<br/>
                                    </Col>
                                </Row>
                            </div>
                            <div className={"borderedContainer mt-2"}>
                                <Row>
                                    <h6>Λεπτομέριες</h6>
                                    <Col md={6}>
                                        <strong>Θετική λίστα: </strong> {drugData.positiveList === "true" ? "Ναι" : "Όχι"}<br/>
                                        <strong>Αρνητική λίστα: </strong> {drugData.negativeList === "true" ? "Ναι" : "Όχι"}<br/>
                                        <strong>Αποσυρμένο: </strong> {drugData.withdrawn === "true" ? "Ναι" : "Όχι"}<br/>
                                        <strong>Σε κυκλοφορία: </strong> {drugData.inCirculation === "true" ? "Ναι" : "Όχι"}<br/>
                                        <strong>Συνταγ/ση μόνο μέσω ΘΠΣ: </strong> {drugData.onlyByProtocol === "true" ? "Ναι" : "Όχι"}<br/>
                                        <strong>Ειδική εισαγωγή: </strong> {drugData.specialImport === "true" ? "Ναι" : "Όχι"}<br/>
                                        <strong>Φάρμακο Ι.Φ.Ε.Τ.: </strong> {drugData.ifet === "true" ? "Ναι" : "Όχι"}<br/>
                                        <strong>Μη Συνταγογραφούμενο: </strong> {drugData.nonPrescriptable === "true" ? "Ναι" : "Όχι"}<br/>
                                        <strong>Νόμου 3816: </strong> {drugData.n3816 === "true" ? "Ναι" : "Όχι"}<br/>
                                    </Col>
                                    <Col md={6}>
                                        <strong>Ναρκωτικά: </strong> {drugData.drug === "true" ? "Ναι" : "Όχι"}<br/>
                                        <strong>Εμβόλιο Απευαισθητοποίησης: </strong> {drugData.desensitizationVaccine === "true" ? "Ναι" : "Όχι"}<br/>
                                        <strong>Αναλώσιμο: </strong> {drugData.isConsumable === "true" ? "Ναι" : "Όχι"}<br/>
                                        <strong>Αντιβιοτικό: </strong> {drugData.isAntibiotic === "true" ? "Ναι" : "Όχι"}<br/>
                                        <strong>Συνταγογράφηση σε ανασφάλιστους: </strong> {drugData.uninsuredAllowed === "true" ? "Ναι" : "Όχι"}<br/>
                                        <strong>Συνταγογράφηση σε ασθενείς εξωτερικού: </strong> {drugData.foreignEnabled === "true" ? "Ναι" : "Όχι"}<br/>
                                        <strong>Συνταγογράφηση σε ασθενείς με ανενεργό ΑΜΚΑ: </strong> {drugData.inactiveAmkaEnabled === "true" ? "Ναι" : "Όχι"}<br/>
                                        <strong>Δυνατότητα παράδοσης κατ'οίκον: </strong> {drugData.isDeliverable === "true" ? "Ναι" : "Όχι"}<br/>
                                        <strong>Απαιτείται ηλ. γνωμ. για παράδοση κατ'οίκον: </strong> {drugData.medOpinionRequired === "true" ? "Ναι" : "Όχι"}<br/>
                                    </Col>
                                </Row>
                            </div>
                            {!isEmpty(drugData.infoPopUp) && (
                                <div className={"borderedContainer mt-2"}>
                                    <Row>
                                        <h6>Προσοχή</h6>
                                        <Col md={12}>
                                            {drugData.infoPopUp}
                                        </Col>
                                    </Row>
                                </div>
                            )}
                        </React.Fragment>
                    )}
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}

export default DrugInfoModal;
